import axios from 'axios'

const materialTagsQuery = async (category, locale) =>
  await axios.get(
    `/api/entities?type=materialTag&fieldName=category&fieldValue=${category}&locale=${locale}`
  )

export default materialTagsQuery
